module.exports = __webpack_public_path__ + "img/interstitial_logo_contents.3ebc8dd5.png";